import { formatDateDisplay } from '../helper/helper';
import flatpickr from 'flatpickr';
import { German } from 'flatpickr/dist/l10n/de';
import { Dutch } from 'flatpickr/dist/l10n/nl';

function getDatePlus(days = 0) {
  const todayDate = new Date();
  return new Date(todayDate.getFullYear(), todayDate.getMonth(), todayDate.getDate() + days);
}

function getLanguageFromUrl() {
  const urlParams = new URLSearchParams(window.location.search);
  const lang = urlParams.get('lang');
  return lang || 'de'; // Default to German
}

function getLocaleConfig(lang) {
  switch (lang) {
    case 'nl':
      return Dutch;
    case 'de':
      return German;
    case 'en':
    default:
      return 'default';
  }
}

// Store references to all datepickers for syncing
let datepickerIn, datepickerOut, datepickerFull;

// Base flatpickr configuration
function getBaseConfig(lang, appendToParent = false) {
  const localeConfig = getLocaleConfig(lang);
  const config = {
    locale: localeConfig,
    dateFormat: 'd.m.Y',
    minDate: 'today',
    maxDate: getDatePlus(365),
    disableMobile: true,
    clickOpens: true,
    mode: 'range',
    static: appendToParent, // This makes flatpickr append to parent instead of body
    position: appendToParent ? 'below' : 'auto',
    monthSelectorType: 'static',
    onChange: (selectedDates, dateStr, instance) => {
      // Update display in datepicker_value element
      const parent = instance.element.closest('.fs__dropdown');
      if (parent) {
        const valueElement = parent.querySelector('.datepicker_value');
        if (valueElement) {
          if (selectedDates.length === 2) {
            valueElement.innerHTML = formatDateDisplay(selectedDates[0]) + ' - ' + formatDateDisplay(selectedDates[1]);
          } else if (selectedDates.length === 1) {
            valueElement.innerHTML = formatDateDisplay(selectedDates[0]);
          } else {
            valueElement.innerHTML = '';
          }
        }
      }
    },
  };
  return config;
}

export function loadFlightSearchCalendars() {
  const lang = getLanguageFromUrl();
  const baseConfig = getBaseConfig(lang, true); // Append to parent for flight search calendars

  const elementPickerFlightParkingIn = $('.flight--schedule.active .parking__date--in');
  const elementPickerFlightParkingOut = $('.flight--schedule.active .parking__date--out');
  const elementPickerFlightSearch = $('.flight--schedule.active .fs__dateSelect');

  if (elementPickerFlightParkingIn.length && elementPickerFlightParkingIn.data('loaded') === false) {
    flatpickr(elementPickerFlightParkingIn[0], {
      ...baseConfig,
      defaultDate: [getDatePlus(2), getDatePlus(8)],
    });
    elementPickerFlightParkingIn.data('loaded', 'true');
  }
  if (elementPickerFlightParkingOut.length && elementPickerFlightParkingOut.data('loaded') === false) {
    flatpickr(elementPickerFlightParkingOut[0], {
      ...baseConfig,
      defaultDate: [getDatePlus(2), getDatePlus(8)],
    });
    elementPickerFlightParkingOut.data('loaded', 'true');
  }
  if (elementPickerFlightSearch.length && elementPickerFlightSearch.data('loaded') === false) {
    flatpickr(elementPickerFlightSearch[0], {
      ...baseConfig,
      minDate: new Date(new Date().getFullYear(), 5, 1), // June 1st of current year
      maxDate: getDatePlus(1),
      defaultDate: [getDatePlus(0), getDatePlus(1)],
    });
    elementPickerFlightSearch.data('loaded', 'true');
  }
}

export function loadFullCalendar() {
  const lang = getLanguageFromUrl();
  const baseConfig = getBaseConfig(lang, true); // Append to parent for parking calendars

  // Helper function to update displays
  function updateDisplays(dates) {
    if (datepickerIn && dates && dates.length > 0) {
      const inParent = datepickerIn.element.closest('.fs__dropdown');
      if (inParent) {
        const valueElement = inParent.querySelector('.datepicker_value');
        if (valueElement) {
          valueElement.innerHTML = formatDateDisplay(dates[0]);
        }
      }
    }
    if (datepickerOut && dates && dates.length > 1) {
      const outParent = datepickerOut.element.closest('.fs__dropdown');
      if (outParent) {
        const valueElement = outParent.querySelector('.datepicker_value');
        if (valueElement) {
          valueElement.innerHTML = formatDateDisplay(dates[1]);
        }
      }
    }
  }

  // Sync function to handle date changes between pickers
  function syncDatepickers(changedPicker, selectedDates) {
    if (changedPicker === 'full') {

      // Full calendar changed - ensure two dates are set
      let setDates = [];
      if (selectedDates.length === 1) {
        setDates = [selectedDates[0], selectedDates[0]];
      } else {
        setDates = selectedDates;
      }

      // Full calendar changed - sync to both in/out pickers
      if (datepickerIn) {
        datepickerIn.setDate(setDates, false);
      }
      if (datepickerOut) {
        datepickerOut.setDate(setDates, false);
      }
      updateDisplays(setDates);
    } else if (changedPicker === 'in' || changedPicker === 'out') {
      const selectedDatesOther = changedPicker === 'in' ? datepickerOut.selectedDates : datepickerIn.selectedDates;

      let startDate = changedPicker === 'in' ? selectedDates[0] : selectedDatesOther[0];
      let endDate = changedPicker === 'out' ? selectedDates[0] : (selectedDatesOther[1] || selectedDatesOther[0]);

      if (!startDate) {
        startDate = endDate;
      }
      if (!endDate) {
        endDate = startDate;
      }

      if (changedPicker === 'in' && startDate > endDate) {
        endDate = startDate;
      } else if (changedPicker === 'out' && startDate > endDate) {
        startDate = endDate;
      }

      const setDates = [startDate, endDate];

      datepickerIn.setDate(setDates, false);
      datepickerOut.setDate(setDates, false);
      updateDisplays(setDates);

      // In or Out picker changed - sync to full calendar
      if (datepickerFull) {
        datepickerFull.setDate(setDates, false);
      }
    }
  }

  // Initialize datepickers
  const parkingInElement = document.querySelector('.parking .parking__date--in');
  const parkingOutElement = document.querySelector('.parking .parking__date--out');
  const fullCalendarElement = document.querySelector('#calendar_full');

  if (parkingInElement) {
    datepickerIn = flatpickr(parkingInElement, {
      ...baseConfig,
      defaultDate: [getDatePlus(2), getDatePlus(6)],
      onChange: (selectedDates, dateStr, instance) => {
        // Call base onChange first
        baseConfig.onChange(selectedDates, dateStr, instance);
        // Then sync with other pickers
        syncDatepickers('in', selectedDates);
        // Close calendar after selection
        instance.close();
      },
    });
  }

  if (parkingOutElement) {
    datepickerOut = flatpickr(parkingOutElement, {
      ...baseConfig,
      defaultDate: [getDatePlus(2), getDatePlus(6)],
      onChange: (selectedDates, dateStr, instance) => {
        // Call base onChange first
        baseConfig.onChange(selectedDates, dateStr, instance);
        // Then sync with other pickers
        syncDatepickers('out', selectedDates);
        // Close calendar after selection
        instance.close();
      },
    });
  }

  if (fullCalendarElement) {
    datepickerFull = flatpickr(fullCalendarElement, {
      ...baseConfig,
      inline: true,
      defaultDate: [getDatePlus(2), getDatePlus(6)],
      onChange: (selectedDates) => {
        syncDatepickers('full', selectedDates);
      }
    });
  }
}
